"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    width: ", "px;\n    position: absolute;\n    top: ", "px;\n    left: ", "px;\n    transform: ", ";\n"], ["\n    width: ", "px;\n    position: absolute;\n    top: ", "px;\n    left: ", "px;\n    transform: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _animateCssStyledComponents = require("animate-css-styled-components");

var _functions = require("../functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DropdownWrapper = _styledComponents2.default.div(_templateObject, function (props) {
    return props.width;
}, function (props) {
    return props.rect.height + props.rect.top;
}, function (props) {
    return (props.position != "left" && props.rect.width) + props.rect.left;
}, function (props) {
    return props.position != "left" && "translateX(-100%)";
});

var Dropdown = function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            visible: _this.props.visible
        };
        return _this;
    }

    _createClass(Dropdown, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if ((0, _functions.isBrowser)()) {
                document.addEventListener("click", this.handleClick);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if ((0, _functions.isBrowser)()) {
                document.removeEventListener("click", this.handleClick, false);
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var _this2 = this;

            if (this.props.visible != this.state.visible) {
                setTimeout(function () {
                    _this2.setState({ visible: _this2.props.visible });
                }, this.state.visible ? this.props.delay : 0);
            }
        }
    }, {
        key: "handleClick",
        value: function handleClick(e) {
            //console.log("test");
            if (this.dropdownWrapper == null) {
                if ((0, _functions.isBrowser)()) {
                    document.removeEventListener("click", this.handleClick, false);
                }
                return;
            }
            if (!this.dropdownWrapper.contains(e.target) && this.props.hideDropdown) {
                this.props.hideDropdown();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var rect = {};
            if (this.props.toggleRef) {
                rect = this.props.toggleRef.getBoundingClientRect();
            }
            return this.state.visible && _react2.default.createElement(
                DropdownWrapper,
                {
                    innerRef: function innerRef(dropdownWrapper) {
                        return _this3.dropdownWrapper = dropdownWrapper;
                    },
                    position: this.props.position,
                    width: this.props.width,
                    delay: this.props.delay,
                    rect: rect
                },
                this.props.children
            );
        }
    }]);

    return Dropdown;
}(_react2.default.Component);

Dropdown.propTypes = {
    position: _propTypes2.default.oneOf(["left", "right"]),
    width: _propTypes2.default.number,
    delay: _propTypes2.default.number,
    visible: _propTypes2.default.bool,
    toggleRef: _propTypes2.default.object,
    hideDropdown: _propTypes2.default.func
};

Dropdown.defaultProps = {
    position: "right",
    width: 100,
    delay: 0,
    visible: false
};

Dropdown.displayName = "Dropdown";

exports.default = Dropdown;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/dropdown.js
// module id = 995
// module chunks = 95715928098905 168707334958949